module.exports = __webpack_public_path__ + "img/plus_btn.2e2b9d74.png";